import { Button, styled } from "@mui/material";

const BlueButtonOutlinedStyled = styled(Button)({
    textTransform: "none",
    fontSize: 14,
    padding: "9px 15px",
    lineHeight: "16px",
    fontWeight: "400",
    borderRadius: "6px",
    border: "1px solid #405289",
    boxShadow: "0px 4px 7px 2px rgba(64, 82, 137, 0.1)",
    color: "#586A84",
    minWidth: "150px",
    height: "39px",
    backgroundColor: "#FFFFFF",
    borderColor: "#405289",
    fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
        backgroundColor: "#D7DEF4",
    },
    "&:active": {
        backgroundColor: "#D7DEF4",
    },
    "&:focus": {
        // boxShadow: '0 0 0 0.2rem rgba(22,75,57,.5)',
    },
});

export default BlueButtonOutlinedStyled;
